module.exports = __webpack_public_path__ + "img/app-cnn.4bdabc42.png";